/** Identifies which widget/flow the order originated from */
export enum PayloadTypeEnum {
  ExternFormEnrollment = "ExternFormEnrollment",
  FormEnrollmentNew = "FormEnrollmentNew",
}
